// src/components/layout/Header.jsx
import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Phone, ArrowRight, Tag } from "lucide-react";
import MobileMenu from "./MobileMenu";
import { siteConfig } from "../../homeComponents/data/siteConfig";
import logo from "../../assets/logo.png";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/tours", label: "Tours & Travels" },
  { to: "/vehicles", label: "Vehicles" },
  { to: "/motors", label: "NJV Motors" },
  { to: "/motors/selling", label: "Buy Vehicles" },
  { to: "/consultancy", label: "Consultancy" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header
        className="
          sticky top-0 z-50
          border-b border-[#E2E8E5]/80
          bg-white/90
          backdrop-blur-xl
          supports-[backdrop-filter]:bg-white/75
        "
      >
        <div
          className="
            mx-auto flex
            h-[68px]
            max-w-7xl
            items-center justify-between
            px-4
            sm:h-[76px]
            sm:px-6
            lg:px-8
          "
        >
          {/* ================= BRAND / LOGO ================= */}
          <Link
            to="/"
            className="
              group flex shrink-0
              items-center
              transition-transform duration-300
              hover:-translate-y-0.5
            "
            aria-label="NJV Tours and Travels Home"
          >
            <img
              src={logo}
              alt="NJV Tours and Travels"
              className="
                h-11
                w-auto
                max-w-[170px]
                object-contain
                transition-transform duration-300
                group-hover:scale-[1.03]
                sm:h-12
                lg:h-14
              "
            />
          </Link>

          {/* ================= DESKTOP NAV ================= */}
          <nav
            className="
              hidden
              items-center
              gap-1
              md:flex
            "
            aria-label="Main navigation"
          >
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className="group relative px-3 py-2"
              >
                {({ isActive }) => (
                  <>
                    <span
                      className={`
                        relative z-10
                        text-[13px]
                        font-semibold
                        transition-colors duration-200
                        ${
                          isActive
                            ? "text-[#005543]"
                            : "text-[#475569] group-hover:text-[#00A260]"
                        }
                      `}
                    >
                      {item.label}
                    </span>

                    {/* Active underline */}
                    <span
                      className={`
                        absolute
                        bottom-0.5
                        left-1/2
                        h-0.5
                        -translate-x-1/2
                        rounded-full
                        bg-[#00A260]
                        transition-all duration-300
                        ${
                          isActive
                            ? "w-5 opacity-100"
                            : "w-0 opacity-0 group-hover:w-3 group-hover:opacity-70"
                        }
                      `}
                    />
                  </>
                )}
              </NavLink>
            ))}
          </nav>

          {/* ================= ACTIONS ================= */}
          <div className="flex items-center gap-2">
            
         

            {/* Desktop Call Button */}
            <a
              href={`tel:${siteConfig.contact.phone}`}
              className="
                group
                hidden
                h-10
                items-center
                gap-2
                rounded-xl
                bg-[#00A260]
                px-4
                text-xs
                font-bold
                text-white
                shadow-md
                shadow-[#00A260]/15
                transition-all duration-300
                hover:-translate-y-0.5
                hover:bg-[#005543]
                hover:shadow-lg
                sm:flex
              "
            >
              <Phone className="h-3.5 w-3.5" />

              <span>Call NJV</span>

              <ArrowRight
                className="
                  h-3.5 w-3.5
                  -translate-x-1
                  opacity-0
                  transition-all duration-200
                  group-hover:translate-x-0
                  group-hover:opacity-100
                "
              />
            </a>

            {/* Mobile — Sell Vehicle */}
            <Link
              to="/motors/sell"
              aria-label="Sell your vehicle"
              className="
                flex h-10 w-10
                items-center justify-center
                rounded-xl
                border border-[#00A260]
                bg-white
                text-[#00A260]
                shadow-sm
                transition-all duration-300
                hover:bg-[#F3FBF7]
                sm:hidden
              "
            >
              <Tag className="h-4 w-4" />
            </Link>

            {/* Mobile Call */}
            <a
              href={`tel:${siteConfig.contact.phone}`}
              aria-label="Call NJV"
              className="
                flex h-10 w-10
                items-center justify-center
                rounded-xl
                bg-[#00A260]
                text-white
                shadow-md
                shadow-[#00A260]/15
                transition-all duration-300
                hover:bg-[#005543]
                sm:hidden
              "
            >
              <Phone className="h-4 w-4" />
            </a>

            {/* Mobile Menu */}
            <button
              type="button"
              onClick={() => setOpen(true)}
              aria-label="Open menu"
              aria-expanded={open}
              className="
                flex h-10 w-10
                items-center justify-center
                rounded-xl
                border border-[#E2E8E5]
                bg-white
                text-[#061A3A]
                transition-all duration-200
                hover:border-[#00A260]/30
                hover:bg-[#F8FAF9]
                hover:text-[#00A260]
                md:hidden
              "
            >
              <Menu className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      {/* ================= MOBILE MENU ================= */}
      <MobileMenu
        open={open}
        onClose={() => setOpen(false)}
        items={navItems}
      />
    </>
  );
};

export default Header;